import { zSchema } from "../../../schema-validation";
import { employeeOnboardSchema } from "./employeeOnboard";

export const updateUserDataSchema = employeeOnboardSchema.extend({
  odo_user_id: zSchema.string(),
});
